<template>
  <section
    class="login-register"
    :style="{
      '--background-landscape': `url(${accessConfig.loginView.bg})`,
      '--background-portrait': `url(${accessConfig.loginView.bgPortrait || accessConfig.loginView.bg})`,
      '--bgColor': bgColor,
      '--panelColor': panelColor,
      '--labelColor': labelColor,
      '--boxShadow': boxShadow,
    }">
    <div class="login-content-container">
      <div class="kv-spacer" v-if="accessConfig.loginView.position == 'right'">
        <img :src="accessConfig.loginView.eventImage" class="login-logo" v-if="accessConfig.loginView.eventImage" />
      </div>
      <div class="outside-inside-container">
        <div class="opt-container" v-if="accessConfig.loginView.panelImageOutside">
          <img :src="accessConfig.loginView.loginPanelImage" class="login-logo" v-if="accessConfig.loginView.loginPanelImage" />
        </div>
        <div class="fields-container">
          <div class="opt-container" v-if="!accessConfig.loginView.panelImageOutside">
            <img :src="accessConfig.loginView.loginPanelImage" class="login-logo" v-if="accessConfig.loginView.loginPanelImage" />
          </div>
          <div class="login-form">
            <div class="register-inputs-wrapper">
              <!-- GENERALIZED INPUT FIELD -->
              <FormInputs ref="formInputs" :fieldGroups="fieldGroups" :user_id="$store.state.user.id" :style="{ '--labelColor': labelColor }" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-wrapper">
      <Footer />
    </div>
  </section>
</template>

<script>
import Footer from '@/components/general/Footer.vue';
import FormInputs from '@/components/general/FormInputs.vue';

export default {
  name: 'UserProfileRegister',
  components: { Footer, FormInputs },

  data() {
    return {
      accessConfig: {},
      panelColor: 'transparent',
      minWidth: 'auto',
      bgColor: '#ffffff',
      labelColor: '#000000',
      boxShadow: '0px 0px 40px 0 rgba(0, 0, 0, 0.0)',
      fieldGroups: [],
    };
  },
  watch: {
    $route() {
      this.accessConfig = this.$store.state.template.accessConfig;
    },
  },
  beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
    let userLanguage = this.$store.state.user.language ? this.$store.state.user.language.toLowerCase() : 'pt';

    if (this.$store.state.template.multilanguagesConfig) {
      this.accessConfig = this.$store.state.template.accessConfig[`accessConfig_${userLanguage}`];
    } // ORDERING INPUT FIELDS ARRAY
    this.fieldGroups = this.accessConfig.registerView.fieldGroups ? this.accessConfig.registerView.fieldGroups.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0)) : [];

    this.fieldGroups.map((group) => {
      group.fields.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
    });

    // CONDITIONS TO LOWER CASE
    this.fieldGroups.map((group) => {
      group.fields.map((field) => {
        if (field.conditional)
          field.conditional.map((item) => {
            item.condition = item.condition.map((cond) => {
              cond = cond.toLowerCase();
              return cond;
            });
          });
      });
    });

    // SET PANEL COLOR TO ADMIN JSON ONLY IF IT EXISTS, ELSE IT´S TRANSPARENT
    if (this.accessConfig.loginView.panelColor) this.panelColor = this.accessConfig.loginView.panelColor;
    if (this.accessConfig.loginView.minWidth != '') this.minWidth = this.accessConfig.loginView.minWidth; // Set additional style variables from config
    if (this.accessConfig.loginView.bgColor) this.bgColor = this.accessConfig.loginView.bgColor;
    if (this.accessConfig.registerView.labelColor) this.labelColor = this.accessConfig.registerView.labelColor;
    this.boxShadow = this.accessConfig.loginView.boxShadow ? this.accessConfig.loginView.boxShadow : this.boxShadow;
  },
};
</script>

<style lang="scss">
/* Add styling for form labels */
.register-inputs-wrapper {
  width: 100%;
  padding: 0;
}

.register-inputs-wrapper :deep(.group-field-title-placeholder) {
  color: var(--labelColor);
  margin-bottom: 5px;
  font-weight: 500;
}
</style>
